import React from 'react'
import { RouteComponentProps } from '@reach/router'

const NotFoundPage = (props: RouteComponentProps) => <div>404 Not Found</div>

export default NotFoundPage
